import styles from "@/components/popup-shell.module.css";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CloseButton, Dialog } from "@headlessui/react";
import clsx from "clsx";
import { t } from "i18next";
import { JSX, ReactNode } from "react";

interface PopupShellProps {
	children: ReactNode;
	isClosing: boolean;
	isOpen: boolean;
	onClose?: () => void;
}

function PopupShell({
	children,
	isClosing,
	isOpen,
	onClose,
}: PopupShellProps): JSX.Element {
	return (
		<Dialog
			onClose={onClose || ((): void => {})}
			open={isOpen}
		>
			<div
				className={clsx(
					"overlay",
					!isClosing && "zoom-in",
					(isClosing || !isOpen) && "zoom-out",
				)}
			>
				<div className={styles["popup"]}>
					{children}
					{!!onClose && (
						<CloseButton
							className={styles["close-button"]}
							title={t("close")}
							onClick={onClose}
						>
							<FontAwesomeIcon icon={faClose} />
						</CloseButton>
					)}
				</div>
			</div>
		</Dialog>
	);
}

export default PopupShell;
